import ServiceProvider from "./serviceProvider";

export default class Trade {
  public idTrade: number = 0;
  public tradeName: string = "";
  public serviceProviders: ServiceProvider[] = [];
}
